import * as React from "react";
import * as naturalSort from "node-natural-sort";

const comparator = naturalSort({ caseSensitive: false });

function naturalSortBy<T>(data: T[] | undefined, sortColumn: string): T[] {
  if (!Array.isArray(data)) {
    return [];
  }

  const cloned = [...data];

  cloned.sort((a, b) => comparator(a[sortColumn], b[sortColumn]));
  return cloned;
}

export function useNaturalSort<T>(
  data: T[] | undefined,
  sortColumn: string
): T[] {
  return React.useMemo<T[]>(() => naturalSortBy<T>(data, sortColumn), [
    data,
    sortColumn,
  ]);
}

export function useNaturalSortByName<T>(data: T[] | undefined): T[] {
  return useNaturalSort(data, "name");
}
